export enum PermissionsType {
  // 能源概览
  P_ENERGYOVERVIEWMOBILE = 'p-energyOverviewMobile',
  // 照明控制
  P_LIGHTINGCONTROLMOBILE = 'p-lightingControlMobile',
  // 用能台账
  P_ENERGYUSAGELEDGERMOBILE = 'p-energyUsageLedgerMobile',
  // 延时计划
  P_DELAYSCHEDULEMOBILE = 'p-delayedScheduleMobile',
  // 延时申请
  P_DELAYREQUESTFORMOBILE = 'p-delayRequestForMobile',
  // 用能计划
  P_ENERGYUSEPLANNINGMOBILE = 'p-energyUsePlanningMobileApp',
  // 用能申请
  P_CANBEAPPLICEDMOBILE = 'p-canBeAppliedMobile',
  // 报警记录
  P_ALARMRECORDMOBILE = 'p-alarmRecordsDashboardMobileVersion',
}
